import styles from "./LandingTitle.module.scss";

type TitleProps = {
  children: React.ReactNode;
};

const LandingTitle = ({ children }: TitleProps) => {
  return <h1 className={styles.root}>{children}</h1>;
};

export default LandingTitle;
